import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { t } from "i18next";

const PujaUnavailableModal = ({ show, onHide, unavailableMsg, unavailableMsgHeader }) => {

    const navigate = useNavigate();

    const handleHome = () => {
        onHide()
        navigate("/");
    };

    return (
        <Modal
            show={show}
            centered
            backdrop="static"
            keyboard={false}
            className="text-center"
        >
            <Modal.Body
                className="d-flex flex-column align-items-center justify-content-center p-4"
                style={{
                    background: "linear-gradient(135deg, #fff8e7, #fce7d3)",
                    borderRadius: "15px",
                }}
            >
                {/* Icon Section */}
                <div
                    className="d-flex align-items-center justify-content-center mb-3"
                    style={{
                        width: "80px",
                        height: "80px",
                        backgroundColor: "#f4b72233",
                        borderRadius: "50%",
                    }}
                >
                    <BsExclamationTriangleFill
                        size={40}
                        style={{ color: "#a52444" }}
                    />
                </div>

                {/* Title */}
                <h4
                    className="fw-bold mb-2"
                    style={{
                        color: "#a52444",
                        fontFamily: "'Poppins', sans-serif",
                    }}
                >
                    {t(unavailableMsgHeader)} !
                </h4>

                {/* Message */}
                <div
                    className="text-muted small"
                >
                    {t(unavailableMsg)}
                </div>

                {/* Home Button */}
                <button
                    className="btn w-100 mt-2 book-btn templeServicesBtn"
                    onClick={() => navigate("/")}
                >
                    <span
                        className="blink-text"

                    >
                        {t("Go to home")}
                    </span>
                </button>
            </Modal.Body>
        </Modal>
    );
};

export default PujaUnavailableModal;
